module.exports = __webpack_public_path__ + "static/media/reupload.a8bdd1fa.svg";


//////////////////
// WEBPACK FOOTER
// ./src/display/modules/Home/CompanyPublic/img/reupload.svg
// module id = 6651
// module chunks = 0